<template>
  <div id="goods">
    <div class="comond_btn">
      <el-button @click="dialogVisible = true">添加广告图</el-button>
    </div>
    <template>
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="广告名称" prop="name"></el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">{{ scope.row.createTime | formatTimer }}</template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">{{ scope.row.updateTime | formatTimer }}</template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.$index, scope.row)">查看</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <!-- 添加dialog -->
    <div>
      <el-dialog
        title="添加广告"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item label="广告图(750*300)" :label-width="formLabelWidth" required>
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'bannerLogo') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'bannerLogo') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="广告详情图(宽度750)" :label-width="formLabelWidth" required>
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandback') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'bannerback') }"
            >
              <img v-if="backImgUrl" :src="backImgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="广告名称" prop="name" :labelWidth="formLabelWidth">
            <el-input v-model="form.name" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handCancer()">取 消</el-button>
          <el-button type="primary" @click="handleSave()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 编辑广告dialog -->
    <div>
      <el-dialog
        title="编辑广告"
        :visible.sync="editDialogVisible"
        width="30%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="ruleForm">
          <el-form-item label="广告图(750*300)" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'bannerLogo') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'bannerLogo') }"
            >
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="广告详情图(宽度750)" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              :data="qiniu"
              action="https://upload-z0.qiniup.com"
              :show-file-list="false"
              :multiple="false"
              :before-upload="(file) => { return handleBeforeUpload(file, 'brandback') }"
              :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'bannerback') }"
            >
              <img v-if="backImgUrl" :src="backImgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="广告名称" :labelWidth="formLabelWidth">
            <el-input v-model="ruleForm.name" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <!-- <el-button @click="editDialogVisible = false">取 消</el-button> -->
          <el-button @click="handleEditCancle() ">取 消</el-button>
          <el-button type="primary" @click="handleEditSubmit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 查看广告dialog -->
    <div>
      <el-dialog title="广告详情" :visible.sync="detaildialogVisible" width="50%">
        <!-- 详情内容 -->
        <el-descriptions class="margin-top" title :column="1" :size="size" border>
          <el-descriptions-item>
            <template slot="label">广告名称</template>
            {{detailData.name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">广告图</template>
            <el-image style="width: 100px; height: 100px" :src="detailData.picUrl"></el-image>
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">广告图详情</template>
            <el-image style="width: 100px; height: 100px" :src="detailData.activityContentUrl"></el-image>
          </el-descriptions-item>
        </el-descriptions>

        <span slot="footer" class="dialog-footer">
          <el-button @click="detaildialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="detaildialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { qiniuupload, queryIndex, addIndex } from '../../api'
import moment from 'moment'
export default {
  data () {
    return {
      publishStatus: 'T', //T上架F 下架
      // paras: {
      //   status: 'T',
      // },
      // travelStatus: [ //  状态列表
      //   {
      //     value: 'T',
      //     label: '已上架'
      //   },
      //   {
      //     value: 'F',
      //     label: '已下架'
      //   }
      // ],
      rules: {
        name: [
          { required: true, message: '请输入广告名称', trigger: 'blur' },
        ],
      },
      size: '',
      detailData: [],
      total: 0,
      currentpageIndex: 1,
      currentpageSize: 10,
      // 品牌背景图
      backImgUrl: '',
      imgUrl: '',//解决图片回显问题
      uploadUrl: '', //  七牛上传地址前缀
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      formLabelWidth: '160px',
      // 添加广告默认关闭弹框
      dialogVisible: false,
      // 详情弹框
      detaildialogVisible: false,
      // 编辑弹框
      editDialogVisible: false,
      // 列表数据
      tableData: [],
      // 初始化
      form: {
        name: '',
      },
      ruleForm: {
        id: '',
        name: '',
      }
    }
  },
  filters: {

    formatTimer: function (value) {
      if (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      } else {
        return "/"
      }

    }
  },

  methods: {
    //筛选
    handleSearch (index) {
      console.log(index);
      this.publishStatus = index
      this.currentpageIndex = 1
      this.queryIndex()
    },
    handCancer () {
      this.dialogVisible = false
      this.imgUrl = ''
      this.backImgUrl = ''
    },
    // 添加广告确定提交
    handleSave () {
      let para = new URLSearchParams()
      para.append('name', this.form.name)
      para.append('picUrl', this.imgUrl)
      para.append('activityContentUrl', this.backImgUrl)
      //请求接口
      addIndex(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          //关闭弹窗
          this.dialogVisible = false
          this.imgUrl = ''
          this.backImgUrl = ''
          this.form = {
            name: '',
          },
            this.queryIndex()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    // 七牛部分
    getToken () {
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        this.qiniu.token = res.data.token
        this.uploadUrl = res.data.bucketUrl
      })
    },
    handleOnSuccess (response, file, fileList, obj) { //  上传成功之后
      // console.log(response, file, fileList, obj)
      // this.form[obj] = this.uploadUrl +'/'+ response.key
      // console.log(this.form[obj])
      if (obj === "bannerback") {
        this.backImgUrl = this.uploadUrl + '/' + response.key
      } else {
        this.imgUrl = this.uploadUrl + '/' + response.key
      }
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    //查看
    handleDetail (index, row) {
      // row 就是当前条目的对象
      // console.log(index, row);
      this.detaildialogVisible = true
      this.detailData = row

    },
    // 编辑点击事件
    handleEdit (index, row) {
      console.log(index, row);
      this.editDialogVisible = true
      this.imgUrl = row.picUrl
      this.backImgUrl = row.activityContentUrl
      this.ruleForm.id = row.id
      this.ruleForm.name = row.name
    },
    //编辑取消
    handleEditCancle () {
      this.editDialogVisible = false
      this.imgUrl = ''
      this.backImgUrl = ''
    },
    // 编辑提交
    handleEditSubmit () {
      let para = new URLSearchParams()
      para.append('id', this.ruleForm.id)
      para.append('name', this.ruleForm.name)
      para.append('picUrl', this.imgUrl)
      para.append('activityContentUrl', this.backImgUrl)
      addIndex(para).then(data => {
        // console.log(data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.editDialogVisible = false
          this.queryIndex()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })

    },
    // 删除
    handleDelete (index, row) {
      // row  当前点击条目
      console.log(row);
      if (index == 0) {
        this.$message({
          message: '首条数据不可删除，只能编辑',
          type: 'error'
        })
      } else {
        let para = new URLSearchParams()
        para.append("id", row.id)
        para.append('picUrl', row.picUrl)
        para.append('activityContentUrl', row.activityContentUrl)
        para.append("isValid", 'F')
        addIndex(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.queryIndex()
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    // 查询列表
    queryIndex () {
      let para = new URLSearchParams()
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      para.append('isValid', this.publishStatus)
      //请求接口
      queryIndex(para).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handelCurrentChange (i) { // 分页
      console.log(i);
      this.currentpageIndex = i
      this.queryIndex()
    },
  },
  //生命周期
  mounted () {
    this.queryIndex()
    // 获取七牛token
    this.getToken()
  }
}

</script>
<style lang="stylus">
#goods {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
